import { ArcElement, Chart, ChartOptions } from 'chart.js'
import React, { useEffect, useMemo, useRef } from 'react'

Chart.register(ArcElement)

interface Props {
	data: number[]
	backgroundColors: string[]
	darkModeEnabled: boolean
}

const DoughnutChart: React.FC<Props> = ({ data, backgroundColors }) => {
	const chart = useRef<Chart<'doughnut', number[], unknown>>()
	const canvasElement = useRef<HTMLCanvasElement | null>(null)

	const chartData = useMemo(
		() => ({
			datasets: [
				{
					data,
					backgroundColor: backgroundColors,
					borderColor: 'transparent',
					borderWidth: 0,
					hoverOffset: 0,
					cutout: '75%',
					radius: '100%',
					circumference: 360,
					borderJoinStyle: 'round' as const,
					spacing: 5,
				},
				{
					data: [100],
					backgroundColor: ['#ffffff'],
					borderColor: 'transparent',
					borderWidth: 0,
					cutout: '79%',
					radius: '111.5%',
					circumference: 360,
					spacing: -5,
					hoverOffset: 0,
				},
			],
		}),
		[data, backgroundColors]
	)

	const chartOptions: ChartOptions<'doughnut'> = {
		animation: { duration: 0 },
		devicePixelRatio: 2,
		responsive: true,
		maintainAspectRatio: true,
		aspectRatio: 1,
		plugins: {
			legend: { display: false },
			tooltip: { enabled: false },
		},
		elements: {
			arc: {
				borderRadius: 20,
			},
		},
	}

	useEffect(() => {
		if (!canvasElement.current) return

		if (chart.current) {
			chart.current.destroy()
		}

		chart.current = new Chart(canvasElement.current, {
			type: 'doughnut',
			data: chartData,
			options: chartOptions,
		})

		return () => {
			if (chart.current) {
				chart.current.destroy()
			}
		}
	}, [chartData])

	return (
		<div
			style={{
				height: '15rem',
				maxHeight: '15rem',
				minHeight: '15rem',
				width: '15rem',
				maxWidth: '15rem',
				minWidth: '15rem',
			}}
			className='doughnut-chart'
		>
			<canvas ref={canvasElement} />
		</div>
	)
}

export default DoughnutChart
